export default {
    computed: {
        $fileUrlBase() {
            const baseUrl = process.env.VUE_APP_FILE_UPLOAD_API;
            return baseUrl.substring(0, baseUrl.length - 4);
        },
    },
};
